// Configure your import map in config/importmap.rb. Read more: https://github.com/rails/importmap-rails
import { Turbo } from "@hotwired/turbo-rails"

// import "../controllers"

import { application } from "../controllers/application.js"

// import ModalWindow from '../controllers/modal_window_controller.js'
// application.register('modal-window', ModalWindow)

import DialogController from '../controllers/dialog_controller.js'
application.register('dialog', DialogController)

import IssueFormController from "../controllers/issue_form_controller.js"
application.register("issue-form", IssueFormController)

import IssueFormHourlySaleryController from "../controllers/issue_form_hourly_salery_controller.js"
application.register("issue-form-hourly-salery", IssueFormHourlySaleryController)

import IssueFormMonthlySalaryController from "../controllers/issue_form_monthly_salery_controller.js"
application.register("issue-form-monthly-salary", IssueFormMonthlySalaryController)

import Toast from '../controllers/toast_controller.js'
application.register('toast', Toast)

import Dropdown from '@stimulus-components/dropdown'
application.register('dropdown', Dropdown)

import SelectController from "../controllers/select_controller.js"
application.register("select", SelectController)

import ZipcodeCity from '../controllers/zipcode_city_controller.js'
application.register('zipcode-city', ZipcodeCity)

import AutocompleteStreet from '../controllers/autocomplete_street_controller.js'
application.register('autocomplete-street', AutocompleteStreet)

import PhoneNumber from '../controllers/phone_number_controller.js'
application.register('phone-number', PhoneNumber)

import FieldSvNumberController from "../controllers/field_sv_number_controller.js"
application.register("field-sv-number", FieldSvNumberController)

import CalcWorkingHours from '../controllers/calc_working-hours_controller.js'
application.register('calc-working-hours', CalcWorkingHours)

import FormHelp from '../controllers/form_help_controller.js'
application.register('form-help', FormHelp)

// import MessageDialogController from "../controllers/message_dialog_controller"
// application.register("message-dialog", MessageDialogController)

// import RedirectController from "../controllers/redirect_controller"
// application.register("redirect", RedirectController)

// import "../channels"

import 'trix'
import "@rails/actiontext"

Turbo.start()

Turbo.StreamActions.redirect = function() {
  Turbo.visit(this.target)
}

// import { far } from "@fortawesome/free-regular-svg-icons"
// import { fas } from "@fortawesome/free-solid-svg-icons"
// import { fab } from "@fortawesome/free-brands-svg-icons"
// import { library } from "@fortawesome/fontawesome-svg-core"
// import "@fortawesome/fontawesome-free/js/all"

// library.add(far, fas, fab)
